import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  fetchHoofdleidingOrganisationLists,
  initialState,
} from '../services/fetchHoofdleidingOrganisationLists'

export { useHoofdleidingOrganisationLists, queryKey }

// Depends on the projectbetrokkenen and labels, so mutating those must invalidate it
const queryKey = ['valuelists-hoofdleiding', 'organisation']

const useHoofdleidingOrganisationLists = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: fetchHoofdleidingOrganisationLists,
    queryKey,
    enabled: hasPermissions,
  })

  return {
    data: data || initialState.data,
  }
}
